<template>
  <div class="wrapper">
    <item-detail v-if="detail.file_url ==false" :detail="detail"></item-detail>
    <file-down v-if="detail.file_url !=false" :detail="detail"></file-down>
  </div>
</template>
<script>
import { userApi } from "@/api/user.js";
import { mapActions, mapGetters } from "vuex";
import itemDetail from "@/components/common/itemDetail.vue";
import fileDown from "@/components/common/fileDown.vue";
export default {
  data() {
    return {
      detail: {}
    };
  },
  methods: {
    ...mapActions(["secondTitle"]),
    getDetail() {
      userApi.cooperationDetail({ id: this.$route.query.id }).then(res => {
        this.detail = res.data;
        console.log(this.detail);
      });
    },
    handleRoute() {
      var arr = [
        "重大专项",
        "国际合作",
        "管理规定",
        "科研项目介绍",
        "获奖项目清单",
        "常用文件下载"
      ];
      this.secondTitle(arr[this.$route.query.type * 1 - 1]);
    }
  },
  mounted() {
    this.handleRoute();
    this.getDetail();
  },
  watch: {
    $route(val, oldval) {
      this.handleRoute();
      this.getDetail();
    }
  },
  components: {
    itemDetail,
    fileDown
  }
};
</script>
<style lang="less" scoped>
@import "./../../../common/minix.less";
.wrapper {
  width: 100%;
  padding: 20 / @rem;
  box-sizing: border-box;
  background: #f2f2f2;
}
</style>


// WEBPACK FOOTER //
// src/components/Cooperation/Children/detail.vue